import { ActiveTicketsChipComponent } from "./active-tickets-chip/active-tickets-chip.component"
import { CommunicationSearchBarComponent } from "./communication-search-bar/communication-search-bar.component"
import { MessageDetailsComponent } from "./message-details/message-details.component"
import { MessagesTableComponent } from "./messages-table/messages-table.component";
import { MessageRedirectButtonComponent } from "./message-redirect-button/message-redirect-button.component";
import { NewTicketButtonComponent } from "./new-ticket-button/new-ticket-button.component"
import { SuggestionDetailsComponent } from "./suggestion-details/suggestion-details.component"
import { SuggestionsTableComponent } from "./suggestions-table/suggestions-table.component"
import { TicketDrawerComponent } from "./ticket-drawer/ticket-drawer.component"

export {
  ActiveTicketsChipComponent,
  CommunicationSearchBarComponent,
  MessageDetailsComponent,
  MessagesTableComponent,
  MessageRedirectButtonComponent,
  NewTicketButtonComponent,
  SuggestionDetailsComponent,
  SuggestionsTableComponent,
  TicketDrawerComponent,
}

export const communicationsComponents = [
  ActiveTicketsChipComponent,
  CommunicationSearchBarComponent,
  MessageDetailsComponent,
  MessagesTableComponent,
  NewTicketButtonComponent,
  SuggestionDetailsComponent,
  SuggestionsTableComponent,
  TicketDrawerComponent,
]
